import { APAC_CHECKOUT_NAME, ApacCheckoutComponent } from "@apac/checkout";
import {
  useContactInformationForm,
  type UseContactInformationFormParams,
} from "@apac/components/checkout";
import {
  PhoneNumberField,
  type PhoneNumberFieldProps,
  TextField,
  type TextFieldProps,
} from "@apac/form-ui";
import { useModuleBEM, useStyles } from "@b2bportal/core-themes";
import type { IContactInfo as ContactInfoFormContext } from "@b2bportal/core-types";
import { useI18nContext } from "@hopper-b2b/i18n";
import clsx from "clsx";
import defaultStyles from "./styles.module.scss";

interface ContactInformationFormProps extends UseContactInformationFormParams {
  emailFieldProps?: Partial<TextFieldProps<ContactInfoFormContext>>;
  phoneNumberFieldProps?: Partial<PhoneNumberFieldProps>;
}

export const ContactInformationForm: React.FC<ContactInformationFormProps> = (
  props
) => {
  const { emailFieldProps, phoneNumberFieldProps } = props;

  const { t } = useI18nContext();
  const styles = useStyles(
    APAC_CHECKOUT_NAME,
    ApacCheckoutComponent.ContactInformationForm,
    defaultStyles
  );
  const [block, cn] = useModuleBEM(
    styles,
    ApacCheckoutComponent.ContactInformationForm
  );

  const {
    context: { formContext },
  } = useContactInformationForm(props);

  return (
    <form className={block}>
      <PhoneNumberField
        formContext={formContext}
        placeholder={t("apac.contactInfo.phoneNumberPlaceholder")}
        label={t("phoneNumber")}
        required
        {...phoneNumberFieldProps}
      />

      <TextField
        formContext={formContext}
        className={clsx(cn("email-input"), emailFieldProps?.className)}
        name="email"
        label={t("apac.contactInfo.emailAddress")}
        placeholder={t("apac.contactInfo.emailAddressPlaceholder")}
        required
        {...emailFieldProps}
      />
    </form>
  );
};
